import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Product } from "../../entity/Product";

interface ProductState {
    products: Product[];
}

const initialState: ProductState = {
    products: [],
};  

const productSlice = createSlice({
    name: "product",
    initialState,
    reducers: {
        setProducts: (state, action: PayloadAction<Product[]>) => {
            state.products = action.payload;
        },
        updateProduct: (state, action: PayloadAction<Product>) => {
            const index = state.products.findIndex(p => p.id === action.payload.id);
            if (index !== -1) {
                state.products[index] = action.payload;
            }
        },
        removeProduct: (state, action: PayloadAction<string>) => {
            state.products = state.products.filter(p => p.id !== action.payload);
        },
    },
});

export const { setProducts, updateProduct, removeProduct } = productSlice.actions;
export default productSlice.reducer;
